// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50fa77b0","453":"d482d4c1","732":"3873d96b","977":"2bd7bbbb"}[chunkId] + ".chunk.js";
};